import { http } from '@martech-solution/utils/utils';

const controller = 'master-data/users';

export const checkAdmin = async () => {
  return http.get<boolean>(`${controller}/check-admin`);
};
